/**
 * Reasons of a skipped item, and of a failed item that a retry can still send (sender mailbox,
 * template or attachment not usable).
 */
export const FINANCING_ENDING_SKIP_REASON = {
  ORDER_REVIEW: 'ORDER_REVIEW',
  MULTIPLE_OPERATORS: 'MULTIPLE_OPERATORS',
  FINANCING_INSTITUTION: 'FINANCING_INSTITUTION',
  CONTACT_UNAVAILABLE: 'CONTACT_UNAVAILABLE',
  MISSING_EMAIL: 'MISSING_EMAIL',
  NOT_FOUND: 'NOT_FOUND',
  MAILBOX_UNUSABLE: 'MAILBOX_UNUSABLE',
  TEMPLATE_UNUSABLE: 'TEMPLATE_UNUSABLE',
  ATTACHMENT_UNUSABLE: 'ATTACHMENT_UNUSABLE',
  CONSENT_REFUSED: 'CONSENT_REFUSED',
  INCLUDED_IN_OTHER_SENDING: 'INCLUDED_IN_OTHER_SENDING',
} as const;

export type FinancingEndingSkipReason =
  (typeof FINANCING_ENDING_SKIP_REASON)[keyof typeof FINANCING_ENDING_SKIP_REASON];

// Codes confirmed by the backend MR !15243 (S4, S5a, S5b-1).
// A code missing here is an unknown reason.
export const FINANCING_ENDING_SKIP_REASON_BY_CODE: Readonly<
  Partial<Record<string, FinancingEndingSkipReason>>
> = {
  'DMS-BC-FE-0005': FINANCING_ENDING_SKIP_REASON.ORDER_REVIEW,
  'DMS-BC-FE-0006': FINANCING_ENDING_SKIP_REASON.MULTIPLE_OPERATORS,
  'DMS-BC-FE-0007': FINANCING_ENDING_SKIP_REASON.FINANCING_INSTITUTION,
  'DMS-BC-FE-0008': FINANCING_ENDING_SKIP_REASON.CONTACT_UNAVAILABLE,
  'DMS-BC-FE-0009': FINANCING_ENDING_SKIP_REASON.MISSING_EMAIL,
  'DMS-BC-FE-0010': FINANCING_ENDING_SKIP_REASON.NOT_FOUND,
  'DMS-BC-FE-0011': FINANCING_ENDING_SKIP_REASON.MAILBOX_UNUSABLE,
  'DMS-BC-FE-0012': FINANCING_ENDING_SKIP_REASON.TEMPLATE_UNUSABLE,
  'DMS-BC-FE-0013': FINANCING_ENDING_SKIP_REASON.ATTACHMENT_UNUSABLE,
  'DMS-BC-FE-0018': FINANCING_ENDING_SKIP_REASON.CONSENT_REFUSED,
  'DMS-BC-FE-0024': FINANCING_ENDING_SKIP_REASON.INCLUDED_IN_OTHER_SENDING,
};
